import {
  ON_GET_CUSTOMER_QUOTATIONS,
  GET_CUSTOMER_QUOTATIONS,
  CUSTOMER_QUOTATIONS_ERROR
} from "../actions/types";

const initialState = {
  customerQuotations: [],
  customerQuotation: null,
  error: {},
  loading: true
};
export default function foo(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ON_GET_CUSTOMER_QUOTATIONS:
      return {
        ...state,
        customerQuotations: [],
        loading: true,
      };
    case GET_CUSTOMER_QUOTATIONS:
      return {
        ...state,
        customerQuotations: payload,
        loading: false,
      };
    case CUSTOMER_QUOTATIONS_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
}